import React from 'react';
import clsx from 'clsx';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { theme } from '@care/material-ui-theme';
import { Typography } from '@care/react-component-lib';
import HTMLSanitizer from '@/components/HTMLSanitizer';

const useStyles = makeStyles(() => ({
  pageFooter: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(5, 3, 6.25),
    backgroundColor: theme.palette.care.grey[100],
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(6, 4),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(6, 3, 8),
    },
  },
  footerBackgroundOverride: {
    backgroundColor: theme.palette.care.white,
  },
  disclaimerWrapper: {
    maxWidth: '800px',
    fontSize: '12px',
    whiteSpace: 'pre-line',
    lineHeight: '16px',
    color: theme.palette.care.grey[700],
  },
  disclaimerParagraph: {
    padding: theme.spacing(2, 0),
  },
}));

export interface AppFooterProps {
  customizedFooterContent?: string | null;
  whiteBackground?: boolean;
}

export default function AppFooter({ customizedFooterContent, whiteBackground }: AppFooterProps) {
  const classes = useStyles();

  return (
    <footer
      className={
        whiteBackground
          ? clsx(classes.pageFooter, classes.footerBackgroundOverride)
          : classes.pageFooter
      }>
      <Grid container className={classes.disclaimerWrapper}>
        {customizedFooterContent && (
          <Grid item xs={12} className={classes.disclaimerParagraph}>
            <HTMLSanitizer html={customizedFooterContent} />
          </Grid>
        )}
        <Grid item xs={12} className={classes.disclaimerParagraph}>
          <Typography careVariant="disclaimer2">
            Backup Care providers are employed and vetted by Care.com, Inc.&apos;s corporate
            affiliates, or by agencies or child care centers in the Care.com Backup Care network.
          </Typography>
        </Grid>
        <Grid item xs={12} className={classes.disclaimerParagraph}>
          <Typography careVariant="disclaimer2">
            Outside of the Backup Care service, Care.com does not employ, recommend, or endorse any
            other care providers or care seekers, including those participating in Care.com&apos;s
            Membership service. Care.com provides information and tools to help care seekers and
            care providers connect and make informed decisions. However, each individual is solely
            responsible for selecting an appropriate care provider or care seeker for themselves or
            their families and for complying with all applicable laws in connection with any
            employment relationship they establish. The information contained in member profiles,
            job posts and applications is supplied by care providers and care seekers themselves and
            is not information generated or verified by Care.com. Care.com does not provide medical
            advice, diagnosis or treatment or engage in any conduct that requires a professional
            license.
          </Typography>
        </Grid>
        <Grid item xs={12} className={classes.disclaimerParagraph}>
          <Typography careVariant="disclaimer2">
            Care.com and &quot;There for you&quot; are service marks or registered service marks of
            Care.com, Inc. © 2007-2022 Care.com, Inc. All rights reserved.
          </Typography>
        </Grid>
        <Grid item xs={12} className={classes.disclaimerParagraph}>
          <Typography careVariant="disclaimer2">
            Care.com® HomePaySM is a service provided by Breedlove and Associates, LLC, a Care.com
            company.
          </Typography>
        </Grid>
      </Grid>
    </footer>
  );
}
